var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "settle-page" },
    [
      _c("div", { staticClass: "top-bar" }, [
        _c(
          "div",
          { staticClass: "top-left" },
          [
            _c(
              "a-button",
              {
                attrs: { size: "small", icon: "arrow-left" },
                on: { click: _vm.backBoard },
              },
              [_vm._v("返回")]
            ),
            _c("span", { staticClass: "top-title" }, [_vm._v("餐饮结算")]),
            _vm.order
              ? [
                  _c("span", { staticClass: "top-order-no" }, [
                    _vm._v(_vm._s(_vm.order.order_no)),
                  ]),
                  _c(
                    "a-tag",
                    { attrs: { color: _vm.statusColor(_vm.order.status) } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.order.statusText ||
                            _vm.statusText(_vm.order.status)
                        )
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _c("div", { staticClass: "top-right" }, [
          _vm.storeName
            ? _c("span", { staticClass: "top-store" }, [
                _vm._v(_vm._s(_vm.storeName)),
              ])
            : _vm._e(),
          _c("span", { staticClass: "top-user" }, [
            _vm._v(_vm._s(_vm.userName)),
          ]),
        ]),
      ]),
      _vm.order
        ? _c("div", { staticClass: "settle-body" }, [
            _c("div", { staticClass: "summary-side" }, [
              _c("div", { staticClass: "sum-head" }, [
                _c("span", { staticClass: "sum-table" }, [
                  _vm._v(_vm._s(_vm.tableLabel)),
                ]),
                _c("span", { staticClass: "sum-no" }, [
                  _vm._v(_vm._s(_vm.order.order_no)),
                ]),
              ]),
              _c("div", { staticClass: "sum-meta" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.order.order_type === "dine_in" ? "堂食" : "外带")
                  ),
                ]),
                _vm.order.person_count
                  ? _c("span", [_vm._v(_vm._s(_vm.order.person_count) + " 人")])
                  : _vm._e(),
                _c("span", [
                  _vm._v("收银员：" + _vm._s(_vm.order.creatorName || "-")),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.order.create_time))]),
              ]),
              _c(
                "div",
                { staticClass: "sum-items" },
                _vm._l(_vm.order.items || [], function (it) {
                  return _c("div", { key: it.id, staticClass: "sum-item" }, [
                    _c("div", { staticClass: "si-main" }, [
                      _c(
                        "div",
                        { staticClass: "si-name" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(it.material_name) +
                              "\n              "
                          ),
                          it.item_status === "added"
                            ? _c("a-tag", { attrs: { color: "orange" } }, [
                                _vm._v("加菜"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.optionsText(it.options_json)
                        ? _c("div", { staticClass: "si-sub" }, [
                            _vm._v(_vm._s(_vm.optionsText(it.options_json))),
                          ])
                        : _vm._e(),
                      it.remark
                        ? _c("div", { staticClass: "si-sub" }, [
                            _vm._v("备注：" + _vm._s(it.remark)),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "si-right" }, [
                      _c("div", { staticClass: "si-qty" }, [
                        _vm._v(
                          "¥" +
                            _vm._s(_vm.fmt(it.unit_price)) +
                            " × " +
                            _vm._s(it.quantity)
                        ),
                      ]),
                      _c("div", { staticClass: "si-amount" }, [
                        _vm._v("¥" + _vm._s(_vm.fmt(it.all_price))),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
              _c("div", { staticClass: "sum-total" }, [
                _c("span", [_vm._v("合计")]),
                _c("span", { staticClass: "sum-total-num" }, [
                  _vm._v("¥" + _vm._s(_vm.fmt(_vm.order.total_amount))),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "pay-side" },
              [
                _vm.result
                  ? _c(
                      "div",
                      { staticClass: "pay-result" },
                      [
                        _c("div", { staticClass: "result-icon" }, [
                          _vm._v("✓"),
                        ]),
                        _c("div", { staticClass: "result-title" }, [
                          _vm._v("结算成功"),
                        ]),
                        _c("div", { staticClass: "result-no" }, [
                          _vm._v(_vm._s(_vm.result.orderNo)),
                        ]),
                        _c("div", { staticClass: "result-rows" }, [
                          _c("div", { staticClass: "r-row" }, [
                            _c("span", [_vm._v("合计")]),
                            _c("span", [
                              _vm._v(
                                "¥" + _vm._s(_vm.fmt(_vm.result.totalAmount))
                              ),
                            ]),
                          ]),
                          Number(_vm.result.discountAmount) > 0
                            ? _c("div", { staticClass: "r-row" }, [
                                _c("span", [_vm._v("会员优惠")]),
                                _c("span", [
                                  _vm._v(
                                    "-¥" +
                                      _vm._s(_vm.fmt(_vm.result.discountAmount))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          Number(_vm.result.eraseAmount) > 0
                            ? _c("div", { staticClass: "r-row" }, [
                                _c("span", [_vm._v("抹零")]),
                                _c("span", [
                                  _vm._v(
                                    "-¥" +
                                      _vm._s(_vm.fmt(_vm.result.eraseAmount))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "r-row r-pay" }, [
                            _c("span", [_vm._v("实收")]),
                            _c("span", [
                              _vm._v(
                                "¥" + _vm._s(_vm.fmt(_vm.result.payAmount))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "r-row" }, [
                            _c("span", [_vm._v("支付方式")]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.payText(_vm.result.payType))),
                            ]),
                          ]),
                        ]),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "large",
                              block: "",
                            },
                            on: { click: _vm.backBoard },
                          },
                          [_vm._v("返回桌面")]
                        ),
                      ],
                      1
                    )
                  : [
                      !_vm.settleReady
                        ? _c("a-alert", {
                            staticClass: "pay-alert",
                            attrs: {
                              type: "warning",
                              showIcon: "",
                              message:
                                "当前订单状态（" +
                                _vm.statusText(_vm.order.status) +
                                "）不可结算",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "pay-card" },
                        [
                          _c("div", { staticClass: "pay-sec-title" }, [
                            _vm._v("会员"),
                          ]),
                          _vm.member
                            ? _c(
                                "div",
                                { staticClass: "member-box" },
                                [
                                  _c("div", { staticClass: "member-info" }, [
                                    _c("div", { staticClass: "member-name" }, [
                                      _vm._v(
                                        _vm._s(_vm.member.contacts || "会员") +
                                          "\n                "
                                      ),
                                      _vm.member.levelName
                                        ? _c(
                                            "span",
                                            { staticClass: "member-level" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.member.levelName)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("div", { staticClass: "member-phone" }, [
                                      _vm._v(
                                        _vm._s(_vm.member.telephone || "")
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { size: "small" },
                                      on: { click: _vm.clearMember },
                                    },
                                    [_vm._v("清除")]
                                  ),
                                ],
                                1
                              )
                            : [
                                _c(
                                  "div",
                                  { staticClass: "member-search" },
                                  [
                                    _c("a-input", {
                                      attrs: {
                                        placeholder:
                                          "手机号 / 姓名 / 卡号 / 会员码",
                                      },
                                      on: { pressEnter: _vm.searchMember },
                                      model: {
                                        value: _vm.memberKeyword,
                                        callback: function ($$v) {
                                          _vm.memberKeyword = $$v
                                        },
                                        expression: "memberKeyword",
                                      },
                                    }),
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { loading: _vm.memberSearching },
                                        on: { click: _vm.searchMember },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.memberResults.length
                                  ? _c(
                                      "div",
                                      { staticClass: "member-results" },
                                      _vm._l(_vm.memberResults, function (m) {
                                        return _c(
                                          "div",
                                          {
                                            key: m.memberId,
                                            staticClass: "member-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.pickMember(m)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mi-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(m.contacts || m.cardNo)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "mi-phone" },
                                              [
                                                _vm._v(
                                                  _vm._s(m.telephone || "")
                                                ),
                                              ]
                                            ),
                                            m.levelName
                                              ? _c(
                                                  "a-tag",
                                                  { attrs: { color: "blue" } },
                                                  [_vm._v(_vm._s(m.levelName))]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "member-tip" }, [
                                  _vm._v("会员价优惠由后端结算时计算"),
                                ]),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "pay-card" }, [
                        _c("div", { staticClass: "pay-sec-title" }, [
                          _vm._v("抹零"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "erase-row" },
                          [
                            _c("a-input-number", {
                              staticStyle: { width: "160px" },
                              attrs: {
                                min: 0,
                                max: Number(_vm.order.total_amount) || 0,
                                precision: 2,
                              },
                              model: {
                                value: _vm.eraseAmount,
                                callback: function ($$v) {
                                  _vm.eraseAmount = $$v
                                },
                                expression: "eraseAmount",
                              },
                            }),
                            _c("span", { staticClass: "erase-tip" }, [
                              _vm._v(
                                "抹零金额不能超过合计 ¥" +
                                  _vm._s(_vm.fmt(_vm.order.total_amount))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "pay-card" },
                        [
                          _c("div", { staticClass: "pay-sec-title" }, [
                            _vm._v("支付方式"),
                          ]),
                          _c("div", { staticClass: "pay-types" }, [
                            _c(
                              "div",
                              {
                                staticClass: "pay-type",
                                class: { active: _vm.payType === "cash" },
                                on: {
                                  click: function ($event) {
                                    _vm.payType = "cash"
                                  },
                                },
                              },
                              [_vm._v("现金")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "pay-type",
                                class: { active: _vm.payType === "wx" },
                                on: {
                                  click: function ($event) {
                                    _vm.payType = "wx"
                                  },
                                },
                              },
                              [_vm._v("微信")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "pay-type",
                                class: { active: _vm.payType === "ali" },
                                on: {
                                  click: function ($event) {
                                    _vm.payType = "ali"
                                  },
                                },
                              },
                              [_vm._v("支付宝")]
                            ),
                          ]),
                          _vm.payType !== "cash"
                            ? [
                                _c("div", { staticClass: "pay-mode-row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pay-mode",
                                      class: { active: _vm.payMode === "bar" },
                                      on: {
                                        click: function ($event) {
                                          _vm.payMode = "bar"
                                        },
                                      },
                                    },
                                    [_vm._v("付款码支付（扫顾客码）")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pay-mode",
                                      class: {
                                        active: _vm.payMode === "qrcode",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.payMode = "qrcode"
                                        },
                                      },
                                    },
                                    [_vm._v("收款码（顾客扫码）")]
                                  ),
                                ]),
                                _vm.payMode === "bar"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "auth-row" },
                                        [
                                          _c("a-input", {
                                            attrs: {
                                              placeholder:
                                                "扫码枪录入顾客付款码",
                                              disabled: !_vm.settleReady,
                                            },
                                            on: { pressEnter: _vm.submitBar },
                                            model: {
                                              value: _vm.authCode,
                                              callback: function ($$v) {
                                                _vm.authCode = $$v
                                              },
                                              expression: "authCode",
                                            },
                                          }),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                loading: _vm.settling,
                                                disabled: !_vm.settleReady,
                                              },
                                              on: { click: _vm.submitBar },
                                            },
                                            [_vm._v("确认支付")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _vm.qr
                                        ? _c(
                                            "div",
                                            { staticClass: "qr-area" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "qr-amount" },
                                                [
                                                  _vm._v(
                                                    "收款：¥" +
                                                      _vm._s(
                                                        _vm.fmt(
                                                          _vm.qr.payAmount
                                                        )
                                                      ) +
                                                      "（以结算为准）"
                                                  ),
                                                ]
                                              ),
                                              _vm.qr.qrBase64
                                                ? _c("img", {
                                                    staticClass: "qr-img",
                                                    attrs: {
                                                      src:
                                                        "data:image/png;base64," +
                                                        _vm.qr.qrBase64,
                                                      alt: "收款码",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm.qrExpired
                                                ? _c(
                                                    "div",
                                                    { staticClass: "qr-tip" },
                                                    [
                                                      _vm._v(
                                                        "收款码已超时，请重新生成"
                                                      ),
                                                    ]
                                                  )
                                                : _vm.qrFailed
                                                ? _c(
                                                    "div",
                                                    { staticClass: "qr-tip" },
                                                    [
                                                      _vm._v(
                                                        "支付失败或已关闭，请重新生成收款码"
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "qr-tip" },
                                                    [
                                                      _vm._v(
                                                        "请顾客使用" +
                                                          _vm._s(
                                                            _vm.payType === "wx"
                                                              ? "微信"
                                                              : "支付宝"
                                                          ) +
                                                          "扫码支付，支付完成后自动结算"
                                                      ),
                                                    ]
                                                  ),
                                              _c(
                                                "div",
                                                { staticClass: "qr-actions" },
                                                [
                                                  _c(
                                                    "a-button",
                                                    {
                                                      attrs: { size: "small" },
                                                      on: {
                                                        click: _vm.createQrcode,
                                                      },
                                                    },
                                                    [_vm._v("重新生成")]
                                                  ),
                                                  _c(
                                                    "a-button",
                                                    {
                                                      attrs: { size: "small" },
                                                      on: {
                                                        click: _vm.cancelQr,
                                                      },
                                                    },
                                                    [_vm._v("取消")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "large",
                                                block: "",
                                                loading: _vm.settling,
                                                disabled: !_vm.settleReady,
                                              },
                                              on: { click: _vm.createQrcode },
                                            },
                                            [_vm._v("生成收款码")]
                                          ),
                                    ],
                              ]
                            : _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "large",
                                    block: "",
                                    loading: _vm.settling,
                                    disabled: !_vm.settleReady,
                                  },
                                  on: { click: _vm.submitCash },
                                },
                                [_vm._v("确认结算")]
                              ),
                        ],
                        2
                      ),
                    ],
              ],
              2
            ),
          ])
        : _c(
            "div",
            { staticClass: "settle-loading" },
            [_c("a-spin", { attrs: { size: "large", tip: "订单加载中..." } })],
            1
          ),
      _c("print-modal", { ref: "printModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }